package com.example.positionahead

import androidx.compose.runtime.DisposableEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    ComposeViewport {
        DisposableEffect(Unit) {
            document.getElementById("loading")?.let { el ->
                el.asDynamic().style.display = "none"
            }
            onDispose { }
        }
        App()
    }
}